import { tap, when } from 'ramda';
import { isLocalDevMode } from '../../../config';

const logInDevMode = when(
  isLocalDevMode,
  tap((v) => console.log(v)),
);

export default logInDevMode;
